export enum UserRole {
  'admin' = 'admin',
  'editor' = 'editor',
  'editor-limited' = 'editor-limited',
  'reader' = 'reader',
  'owner' = 'owner',
  'team-member' = 'team-member',
}
